import BaseService from './base'

export default class SuperAppUserService extends BaseService {
  private serviceName = 'spa/user'
  constructor(config: ServiceInitParams) {
    const { timeout, baseURL, appId } = config
    super({ timeout, baseURL, appId })
  }

  public getProfile(): Promise<ProfileResponse> {
    return this.request<ProfileResponse>(
      `${this.serviceName}/v2/users/profile`,
      {
        method: 'GET',
      }
    )
  }

  public getAllMemberPoint(): Promise<MemberPointResponse> {
    return this.request<MemberPointResponse>(
      `${this.serviceName}/v1/users/member-point`,
      {
        method: 'GET',
      }
    )
  }
}
